import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
  };
  return (
    <div className="text-white flex justify-between items-center h-24 max-w-[1240px] mx-auto p-4">
      <h1 className="w-full text-3xl font-bold text-[#00df9a]">REACT.</h1>
      <ul className="hidden md:flex">
        <a href="#"><li className="p-4">Home</li></a>
        <a href="#"><li className="p-4">Company</li></a>
        <a href="#"><li className="p-4">Resources</li></a>
        <a href="#"><li className="p-4">About</li></a>
        <a href="#"><li className="p-4">Contact</li></a>
        
      </ul>
      <div onClick={handleNav} className="block md:hidden">
        {nav ? (
          <AiOutlineClose size={20}></AiOutlineClose>
        ) : (
          <AiOutlineMenu size={20} />
        )}
      </div>
          
      <ul
        className={
          nav
            ? "fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500"
            : "ease-in-out duration-500 fixed left-[-100%]"
        }
      >
        <h1 className="w-full text-3xl font-bold text-[#00df9a] m-4">REACT.</h1>
        <a href="#"><li className="p-4 border-b border-gray-600">Home</li></a>
        <a href="#"><li className="p-4 border-b border-gray-600">Company</li></a>
        <a href="#"><li className="p-4 border-b border-gray-600">Resources</li></a>
        <a href="#"><li className="p-4 border-b border-gray-600">About</li></a>
        <a href="#"> <li className="p-4">Contact</li></a>
       
      </ul>
    </div>
  );
};

export default Navbar;
